import Actions from "../Types";

const initialState = {
    isGettingNameEnquiryValues: false,
    getNameEnquiryValuesSuccess: false,
    nameEnquiryValues: {},
    isSendingNameEnquiryValues: false,
    sendNameEnquiryValuesSuccess: false,
    sendNameEnquiry: {},
    isSendingFundTransferValues: false,
    sendFundTransferValuesSuccess: false,
    sendFundTransfer: {},
    isSendingStatusQueryValues: false,
    sendStatusQueryValuesSuccess: false,
    sendStatusQuery: {},
    error: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_NAME_ENQUIRY_VALUES_START:
            return {
                ...state,
                isGettingNameEnquiryValues: true,
                getNameEnquiryValuesSuccess: false,
                nameEnquiryValues: {},
                error: null,
            };
        case Actions.GET_NAME_ENQUIRY_VALUES_SUCCESS:
            return {
                ...state,
                isGettingNameEnquiryValues: false,
                getNameEnquiryValuesSuccess: true,
                nameEnquiryValues: action.payload,
                error: null,
            };
        case Actions.GET_NAME_ENQUIRY_VALUES_FAILURE:
            return {
                ...state,
                isGettingNameEnquiryValues: false,
                getNameEnquiryValuesSuccess: false,
                nameEnquiryValues: {},
                error: action.payload,
            };
        case Actions.SEND_NAME_ENQUIRY_VALUES_START:
            return {
                ...state,
                isSendingNameEnquiryValues: true,
                sendNameEnquiryValuesSuccess: false,
                sendNameEnquiry: {},
                error: null,
            };
        case Actions.SEND_NAME_ENQUIRY_VALUES_SUCCESS:
            return {
                ...state,
                isSendingNameEnquiryValues: false,
                sendNameEnquiryValuesSuccess: true,
                sendNameEnquiry: action.payload,
                error: null,
            };
        case Actions.SEND_NAME_ENQUIRY_VALUES_FAILURE:
            return {
                ...state,
                isSendingNameEnquiryValues: false,
                sendNameEnquiryValuesSuccess: false,
                sendNameEnquiry: {},
                error: action.payload,
            };
        case Actions.SEND_FUND_TRANSFER_VALUES_START:
            return {
                ...state,
                isSendingFundTransferValues: true,
                sendFundTransferValuesSuccess: false,
                sendFundTransfer: {},
                error: null,
            };
        case Actions.SEND_FUND_TRANSFER_VALUES_SUCCESS:
            return {
                ...state,
                isSendingFundTransferValues: false,
                sendFundTransferValuesSuccess: true,
                sendFundTransfer: action.payload,
                error: null,
            };
        case Actions.SEND_FUND_TRANSFER_VALUES_FAILURE:
            return {
                ...state,
                isSendingFundTransferValues: false,
                sendFundTransferValuesSuccess: false,
                sendFundTransfer: {},
                error: action.payload,
            };
        case Actions.SEND_STATUS_QUERY_VALUES_START:
            return {
                ...state,
                isSendingStatusQueryValues: true,
                sendStatusQueryValuesSuccess: false,
                sendStatusQuery: {},
                error: null,
            };
        case Actions.SEND_STATUS_QUERY_VALUES_SUCCESS:
            return {
                ...state,
                isSendingStatusQueryValues: false,
                sendStatusQueryValuesSuccess: true,
                sendStatusQuery: action.payload,
                error: null,
            };
        case Actions.SEND_STATUS_QUERY_VALUES_FAILURE:
            return {
                ...state,
                isSendingStatusQueryValues: false,
                sendStatusQueryValuesSuccess: false,
                sendStatusQuery: {},
                error: action.payload,
            };
        case Actions.CLEAR_NIP_SUCCESS_STATE:
            return {
                ...state,
                sendNameEnquiryValuesSuccess: false,
                sendFundTransferValuesSuccess: false,
                sendStatusQueryValuesSuccess: false,
            };
        case Actions.CLEAR_NIP_INTERACTION_STATE:
            return initialState;
        default:
            return state;
    }
};
